import React from 'react';
import LogoIcon from '../common/Logo/LogoIcon/LogoIcon';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { getAppName } from 'src/utils/app';

interface LogoContainerProps {
  title: string;
}

const logoSize = '48px';
const brandclubLogoWidth = '72px';
const brandclubLogoHeight = '11px';
// stackline-logo.svg is a wordmark (3431x615), not a square mark.
const stacklineLogoWidth = '180px';
const stacklineLogoHeight = '32px';

export default function LogoContainer({ title }: LogoContainerProps) {
  const appName = getAppName();
  const isBrandclubOS = appName === 'BrandclubOS';
  const isStackline = appName === 'Stackline';
  const logoWidth = isStackline ? stacklineLogoWidth : isBrandclubOS ? brandclubLogoWidth : logoSize;
  const logoHeight = isStackline ? stacklineLogoHeight : isBrandclubOS ? brandclubLogoHeight : logoSize;

  return (
    <Flex flexDirection="column" alignItems="center">
      <Flex justifyContent="center">
        <div
          style={{
            width: logoWidth,
            height: logoHeight,
            maxHeight: logoHeight,
            maxWidth: logoWidth,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <LogoIcon
            height={logoHeight}
            width={logoWidth}
            style={{ width: logoWidth, height: logoHeight, maxWidth: '100%', maxHeight: '100%' }}
          />
        </div>
      </Flex>
      {/* The Stackline asset already spells the name; a wordmark plus an
          uppercase repeat of the same word reads as a mistake. */}
      {!isStackline && (
      <Text
        variant="h4"
        textAlign="center"
        transform="uppercase"
        fontWeight={600}
        sx={{
          fontFamily: "'Geist'",
          fontSize: '26px',
          marginTop: '8px',
          letterSpacing: '2.5px',
          color: colors.darkBlue
        }}
      >
        {title}
      </Text>
      )}
    </Flex>
  );
}
